import { alpha } from '@mui/material/styles';
import { IsDSM, IsEmployee, IsImpersonationMode, IsProduction, IsMerchandisingProgram, IsTest, IsDev } from 'config/config';

export const getDealerPortalHeaderColors = (theme, isNonProduction) => {
  if (!isNonProduction) {
    return {
      toolbarBackground: theme.palette.primary.main,
      navBackground: theme.palette.primary.dark,
      titleBackground: 'transparent',
      accentBackground: alpha(theme.palette.common.white, 0.14),
      borderColor: alpha(theme.palette.common.white, 0.18),
      hoverBackground: alpha(theme.palette.common.white, 0.08),
    };
  }

  return {
    toolbarBackground: theme.palette.error.main,
    navBackground: '#b51219',
    titleBackground: alpha(theme.palette.common.white, 0.12),
    accentBackground: alpha(theme.palette.common.white, 0.16),
    borderColor: alpha(theme.palette.common.white, 0.28),
    hoverBackground: alpha(theme.palette.common.white, 0.12),
  };
};

export const getDealerPortalHeaderButtonSx = (theme, isNonProduction) => {
  const headerColors = getDealerPortalHeaderColors(theme, isNonProduction);

  if (!isNonProduction) {
    return {
      boxShadow: 'none',
      minWidth: 'auto',
      px: { xs: 1, md: 1.5 },
      color: theme.palette.common.white,
      backgroundColor: 'transparent',
      border: '1px solid transparent',
      '&:hover': {
        boxShadow: 'none',
        backgroundColor: headerColors.hoverBackground,
        borderColor: 'transparent',
      },
    };
  }

  return {
    boxShadow: 'none',
    minWidth: 'auto',
    px: { xs: 1, md: 1.5 },
    color: theme.palette.common.white,
    backgroundColor: headerColors.accentBackground,
    border: `1px solid ${headerColors.borderColor}`,
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: headerColors.hoverBackground,
      borderColor: theme.palette.common.white,
    },
  };
};

export const getDealerPortalStateDisplay = t => {
  const environmentKey = IsProduction
    ? 'dealerPortalState.environment.production'
    : IsTest
    ? 'dealerPortalState.environment.test'
    : IsDev
    ? 'dealerPortalState.environment.development'
    : 'dealerPortalState.environment.nonProduction';

  const roleKey = IsDSM
    ? 'dealerPortalState.role.dsm'
    : IsMerchandisingProgram
    ? 'dealerPortalState.role.merchandisingProgram'
    : IsEmployee
    ? 'dealerPortalState.role.employee'
    : null;

  const environmentLabel = IsProduction ? null : t(environmentKey);
  const roleLabel = roleKey ? t(roleKey) : null;
  const labelParts = [environmentLabel, roleLabel].filter(Boolean);

  return {
    environmentLabel,
    roleLabel,
    label: labelParts.length > 0 ? labelParts.join(' | ') : null,
    isImpersonationMode: IsImpersonationMode,
    isNonProduction: !IsProduction,
  };
};

export const getCurrentDealerIdentifier = (dealer, fallbackDealerId = null) => {
  return dealer?.identifier || dealer?.dealerIdentifier || dealer?.dealerNumber || fallbackDealerId || null;
};
